import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ApproveItemModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ApproveItemModalContainer" */
      './ApproveItemModalContainer'
    ),
  loading: LoadingModal,
});
